import { useEffect, useMemo, useState } from "react";
import { CatmullRomCurve3, Vector3 } from "three";
import { parseLandXML } from "./parseLandXML";
import { useProject } from "./ProjectContext";

export interface CenterlineData {
  curve: CatmullRomCurve3;
  totalLength: number;
}

/**
 * Hook that fetches and parses the tunnel centerline, returning the curve.
 * Uses the active project's centerline endpoint from context.
 */
export function useTunnelCenterline(): CenterlineData | null {
  const project = useProject();
  const [points, setPoints] = useState<Vector3[] | null>(null);

  useEffect(() => {
    setPoints(null); // reset when project changes
    fetch(project.centerlineEndpoint)
      .then((r) => r.text())
      .then((xml) => parseLandXML(xml))
      .then((result) => setPoints(result.points))
      .catch((e) => console.error("Failed to load tunnel centerline:", e));
  }, [project.centerlineEndpoint]);

  return useMemo(() => {
    if (!points || points.length < 2) return null;
    const curve = new CatmullRomCurve3(points, false, "catmullrom", 0.5);
    return { curve, totalLength: curve.getLength() };
  }, [points]);
}
